/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {
    Box,
    Text
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useRefinements} from '../../../hooks/use-refinements'
import {useBrand} from '../../../contexts/brand-context'

const NoFilterMatch = ({
    filter,
    productSearchResult,
    category,
    selectedFilters
}) => {
    const intl = useIntl()
    const {isGarage} = useBrand()
    const {toggleFilter} = useRefinements({
        refinements: productSearchResult?.refinements,
        category: category
    })

    return (
        <Box backgroundColor={'alternativeWarning.100'}
            color={'warningText'}
            padding={{base: 4}}
            mt={{base: 4}}>
            <Text fontSize={{base: 'sm'}}
                fontWeight={{base: 'bold'}}
                lineHeight={{base: '16px'}}
                letterSpacing={{base: '0%'}}
                textTransform={{base: 'uppercase'}}
                mb={{base: 2}}>
                {intl.formatMessage({
                    defaultMessage: 'No exact matches',
                    id: 'no_filter_match.title'
                })}
            </Text>
            <Text fontSize={{base: 'xs'}}
                lineHeight={{base: '15px'}}
                letterSpacing={{base: '0%'}}
                mb={{base: 2}}>
                {isGarage
                    ? intl.formatMessage({
                          defaultMessage: 'Try changing or removing some of your filters or adjusting your search area.',
                          id: 'no_filter_match.description.garage'
                      })
                    : intl.formatMessage({
                          defaultMessage: 'Try changing or removing some of your filters or adjusting your search area.',
                          id: 'no_filter_match.description.dynamite'
                      })}
            </Text>
            <Text fontSize={{base: 'xs'}}
                lineHeight={{base: '15px'}}
                letterSpacing={{base: '1%'}}
                textDecor={{base: 'underline'}}
                cursor={{base: 'pointer'}}
                onClick={() => {
                    if (filter?.attributeId === 'price' && filter?.values?.length > 0 && selectedFilters) {
                        toggleFilter({value: selectedFilters[filter.attributeId]}, filter.attributeId, true)
                    }
                }}>
                {intl.formatMessage({
                        id: 'no_filter_match.clear',
                        defaultMessage: 'Clear {filterLabel} Filter'
                    },
                    {filterLabel: filter?.label}
                )}
            </Text>
        </Box>
    )
}

NoFilterMatch.propTypes = {
    filter: PropTypes.object,
    productSearchResult: PropTypes.object,
    category: PropTypes.object,
    selectedFilters: PropTypes.object
}

export default NoFilterMatch
